/* eslint-disable */
import createIcon from '../createIcon';

const IconMoreOutlined = createIcon({
  name: 'icon-more-outlined',
  content: '<path d="M512.356 760.889c54.983 0 99.555 44.572 99.555 99.555 0 54.983-44.572 99.556-99.555 99.556-54.983 0-99.556-44.573-99.556-99.556s44.573-99.555 99.556-99.555zm0-348.445c54.983 0 99.555 44.573 99.555 99.556s-44.572 99.556-99.555 99.556c-54.983 0-99.556-44.573-99.556-99.556s44.573-99.556 99.556-99.556zm0-348.444c54.983 0 99.555 44.573 99.555 99.556s-44.572 99.555-99.555 99.555c-54.983 0-99.556-44.572-99.556-99.555C412.8 108.573 457.373 64 512.356 64z" fill="currentColor" fill-rule="evenodd"/>',
  width: 1024,
  height: 1024
}, 'Icon');
export default IconMoreOutlined;
